module.exports = __webpack_public_path__ + "static/img/bg5.60525d1e.jpg";